import * as z from 'zod';

export const EcmCriterionAnswerSchema = z.object({
  id: z.string(),
  answer: z.boolean().optional(),
  notes: z.string().optional(),
});

export const EcmEntrySchema = z.object({
  id: z.string(),
  criteria: z.array(EcmCriterionAnswerSchema),
});

export const AuditEcmsFormSchema = z.object({
  type: z.literal('ecms'),
  ecms: z.array(EcmEntrySchema),
});

export type AuditEcmsForm = z.infer<typeof AuditEcmsFormSchema>;
